import pathOr from 'ramda/src/pathOr'

export default pathOr([], ['app', 'userData', 'publisher'])
